import { Col } from 'antd';
import { useTranslation } from 'react-i18next';
import TextAreaField from '../../../../components/fields/TextAreaField';

type NameProps = {
    name: string;
    disabled?: boolean;
};

const PackageDescriptionTypeFieldGroup = ({ name, disabled = false }: NameProps) => {
    const { t } = useTranslation(['variantConfiguratorDetails']);

    return (
        <Col lg={8} xs={24}>
            <TextAreaField
                {...t('variantConfiguratorDetails:fields.packages.packageTypeDescription', { returnObjects: true })}
                autoSize={{ minRows: 2, maxRows: 3 }}
                disabled={disabled}
                name={`${name}packageType.packageTypeWithDescriptionInput.description`}
                required
            />
        </Col>
    );
};

export default PackageDescriptionTypeFieldGroup;
